import { render, staticRenderFns } from "./GPathProductPage.vue?vue&type=template&id=1f81e0e4"
import script from "./GPathProductPage.vue?vue&type=script&lang=js"
export * from "./GPathProductPage.vue?vue&type=script&lang=js"
import style0 from "./GPathProductPage.vue?vue&type=style&index=0&id=1f81e0e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports